/**
 * Mobile view constants and types for the application
 * This file centralizes all mobile view related definitions to avoid duplication
 */

// Mobile view constants for type safety
export const MOBILE_VIEWS = {
    CARDS: "cards",
    HIT_DETAIL: "hitDetail", 
    COMMENTS: "comments"
} as const;

// Mobile view type definitions - automatically derived from constants
export type MobileViewState = typeof MOBILE_VIEWS[keyof typeof MOBILE_VIEWS];

// Type alias for backward compatibility
export type MobileViewType = MobileViewState;